import request from '../request';

export const registerOrgId = ({
  userId,
  domain,
  orgName,
  declareDataSovereignty,
  acknowledgeShareNdis,
}) =>
  request.base.put(
    'v2/user/registerOrg',
    {
      orgName,
      domain,
      declareDataSovereignty,
      acknowledgeShareNdis,
    },
    {
      headers: {
        'user-id': userId,
      },
    },
  );

export const getUserMeta = (userId) =>
  request.base.get(
    'v2/user/getUserMeta',
    {},
    {
      headers: {
        'user-id': userId,
      },
    },
  );

export const getUserInfo = (userId) =>
  request.base.get(
    'v2/user/userInfo',
    {},
    {
      headers: {
        'user-id': userId,
      },
    },
  );

export const getOrgs = (userId) =>
  request.base.get(
    'v2/user/orgs',
    {},
    {
      headers: {
        'user-id': userId,
        'use-login-token': true,
      },
    },
  );

export const getMinimalUserInfo = (userId) =>
  request.base.get(
    'v2/user/userInfo',
    {},
    {
      headers: {
        'user-id': userId,
      },
    },
  );

export const sendVerificationEmail = (userId) =>
  request.base.post(
    'v2/user/verifyEmail',
    {},
    {
      headers: {
        'user-id': userId,
      },
    },
  );

export const updateUserInformation = ({ userId, firstName, lastName, email }) =>
  request.base.post(
    'v2/user/updateUserInfo',
    {
      firstName,
      lastName,
      email,
    },
    {
      headers: {
        'user-id': userId,
      },
    },
  );

export const reqAppToSlack = ({ phone, orgId, userId }) =>
  request.base.post(
    'v2/user/premiumReqAppToSlack',
    {
      phone,
    },
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const signTermsAndConditions = ({ userId }) =>
  request.base.put(
    'v2/user/signTandC',
    {},
    {
      headers: {
        'user-id': userId,
      },
    },
  );

export const forgotPassword = ({ email }) =>
  request.base.post('v2/user/forgotPassword', { email }, { headers: {} });
